<div class="modal notification-modal" tabindex="-1" role="dialog" *ngIf="activateModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="close()" data-dismiss="modal" aria-label="Close"><span
                    aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">Runtime Tests</h4>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="card">
                        <div class="col-xs-12">
                            <div class="col-xs-7">
                                <button type="button" class="run-play" (click)="startTest()" data-dismiss="modal"
                                        aria-label="Start"><span class="run-stop-button">START</span>
                                </button>
                            </div>

                            <div class="col-xs-7">
                                <button type="button" class="run-stop" (click)="stopTest()" data-dismiss="modal"
                                        aria-label="Close"><span class="run-stop-button">STOP</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="card">
                        <div class="col-xs-1">
                            Volume:
                        </div>
                        <div class="volume-progress" [ngStyle]="{'width': volumeProgress + 'px'}"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="card">
                        <div class="col-xs-1">
                            Status:
                        </div>
                        <div style="white-space:pre-wrap;">{{status}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-backdrop fade in" *ngIf="activateModal"></div>
